import React, { useCallback, useEffect, useState } from 'react';

import { format, parseISO } from 'date-fns';
import { Table } from 'react-bootstrap';
import { FaSimCard, FaPlusCircle } from 'react-icons/fa';
import { useToast } from '../../../hooks/toast';
import api from '../../../services/api';
import getResponseErrors from '../../../utils/getResponseErrors';

import Modal from '../../Modal';
import Skeleton from '../../Skeleton';
import ChipCadastro from './ChipCadastro';
import ChipDelete from './ChipDelete';

import {
  Card,
  CardBody,
  CardHeader,
  ButtonAdd,
} from '../../../pages/CartaoSaudeDetalhe/styles';
import { ICartaoSaude } from '../../../pages/CartaoSaudeDetalhe';

interface IChipDTO {
  ChiCodigo: number;
  ChiPlaCodigo: number;
  ChiNumero: string;
  ChiTelefone: string;
  ChiDataInicio: Date;
  ChiDataInicioFormatado: string;
  ChiDataExclusao?: Date;
  ChiDataExclusaoFormatado: string;
  excluido: boolean;
}

type Props = {
  plaCodigo: number;
  updated_at: Date;
  exibeBotoesEdicao: boolean;
  handleFecharComponent(dados: ICartaoSaude): void;
};
const ChipTelefonia: React.FC<Props> = ({
  updated_at,
  plaCodigo,
  exibeBotoesEdicao,
  handleFecharComponent,
}) => {
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [showModalCadastro, setShowModalCadastro] = useState(false);
  const [chips, setChips] = useState<IChipDTO[]>();

  const handleFormataChip = useCallback((dados: IChipDTO[]) => {
    const chipsFormatado = dados.map(chip => {
      return {
        ...chip,
        ChiDataInicioFormatado: format(
          parseISO(chip.ChiDataInicio.toString()),
          'dd/MM/yyyy',
        ),
        ChiDataExclusaoFormatado: chip.ChiDataExclusao
          ? format(parseISO(chip.ChiDataExclusao.toString()), 'dd/MM/yyyy')
          : '',
        excluido: !!chip.ChiDataExclusao,
      };
    });
    return chipsFormatado;
  }, []);

  const loadDados = useCallback(
    async (codigoPlano: number): Promise<void> => {
      setLoading(true);
      try {
        const response = await api.get<IChipDTO[]>(
          `/planos/chips/${codigoPlano}`,
        );

        if (response.data.length > 0) {
          const chipsFormatados = handleFormataChip(response.data);
          setChips(chipsFormatados);
        }
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível carregar os chips',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [handleFormataChip, addToast],
  );

  useEffect(() => {
    if (plaCodigo && plaCodigo > 0) loadDados(plaCodigo);
  }, [plaCodigo, loadDados]);

  return (
    <>
      {showModalCadastro && (
        <Modal
          show={showModalCadastro}
          titulo="Cadastro de Chips"
          handleFecharModal={() => setShowModalCadastro(false)}
        >
          <ChipCadastro
            plaCodigo={plaCodigo}
            updated_at={updated_at}
            handleFecharComponent={dados => {
              setShowModalCadastro(false);
              handleFecharComponent(dados);
              loadDados(plaCodigo);
            }}
          />
        </Modal>
      )}

      <Card>
        <CardHeader>
          <span>
            <FaSimCard size={15} /> <b>CHIPS</b>
          </span>
          {exibeBotoesEdicao && (
            <ButtonAdd type="button" onClick={() => setShowModalCadastro(true)}>
              <FaPlusCircle size={15} />
            </ButtonAdd>
          )}
        </CardHeader>

        <CardBody style={{ height: '232px' }}>
          <Table className="text-secondary" hover size="sm">
            <thead>
              <tr className="bg-light text-dark">
                <th>Numero Chip</th>
                <th>Telefone</th>
                <th>Data Adesão</th>
                <th>Data Exclusão</th>
                <th>-</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td>
                    <Skeleton />
                  </td>
                  <td>
                    <Skeleton />
                  </td>
                  <td>
                    <Skeleton />
                  </td>
                  <td>
                    <Skeleton />
                  </td>
                  <td>
                    <Skeleton />
                  </td>
                </tr>
              )}
              {!loading && (!chips || chips?.length === 0) && (
                <tr>
                  <td colSpan={5} style={{ textAlign: 'center' }}>
                    <b>Nenhuma linha cadastrada</b>
                  </td>
                </tr>
              )}
              {!loading &&
                chips &&
                chips.length > 0 &&
                chips.map(chi => (
                  <tr
                    key={`chip-${chi.ChiCodigo}`}
                    style={
                      chi.excluido ? { textDecoration: 'line-through' } : {}
                    }
                  >
                    <td>{chi.ChiNumero}</td>
                    <td>{chi.ChiTelefone}</td>
                    <td>{chi.ChiDataInicioFormatado}</td>
                    <td>{chi.ChiDataExclusaoFormatado}</td>
                    <td>
                      {exibeBotoesEdicao && !chi.excluido && (
                        <ChipDelete
                          chiCodigo={chi.ChiCodigo}
                          plaCodigo={plaCodigo}
                          updated_at={updated_at}
                        />
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </>
  );
};

export default ChipTelefonia;
